import { API, setAuthToken } from '../../../config/API.js';
import { GET_INQUIRY, SET_LOADING_INQUIRY, SET_PAGINATION_INQUIRY } from '../constant.js';

export const getInquiry = (params) => {
  return (dispatch) => {
    const token = localStorage.getItem("jwt_token");
    setAuthToken(token);
    dispatch({
      type: SET_LOADING_INQUIRY,
      payload: true,
    });
    API.get(`admin/inquiry?${new URLSearchParams(params).toString()}`)
      .then((res) => {
        dispatch({
          type: GET_INQUIRY,
          payload: res?.data?.data || [],
        });
        dispatch({
          type: SET_PAGINATION_INQUIRY,
          payload: res?.data?.data?.last_page,
        });
      })
      .catch(() => {
        dispatch({
          type: GET_INQUIRY,
          payload: [],
        });
        dispatch({
          type: SET_PAGINATION_INQUIRY,
          payload: 0,
        });
      });
  };
};

export const addInquiry = (params) => {
  const token = localStorage.getItem("jwt_token");
  setAuthToken(token);
  return API.post("admin/inquiry/add", params);
};

export const getDetailInquiry = (code) => {
  const token = localStorage.getItem("jwt_token");
  setAuthToken(token);
  return API.get(`admin/inquiry/${code}`);
};

export const updInquiry = (params) => {
  const token = localStorage.getItem("jwt_token");
  setAuthToken(token);
  return API.post("admin/inquiry/edit", params);
};

export const delInquiry = (code) => {
  const token = localStorage.getItem("jwt_token");
  setAuthToken(token);
  return API.delete("admin/inquiry/delete/" + code);
};
